import React from 'react'
import PropTypes from 'prop-types';
import Sample from './sample'
import Error from './error'
import Button from './button/button'

class ErrorSample extends Sample {

    state = {}

    pathI18n = 'sample.app.components.error.'

    getTitle() {
        return this.pathI18n + 'page.title'
    }

    home() {
        this.props.history.push('/')
    }

    getBody() {
        return <div className="sample sample-error error">
            <Error message="sample.app.error.404.title" />
            <p><Error message="sample.app.error.404.desc" /></p>
            <p><Error message="app.return" /></p>
            <p><Button label='app.home' onClick={this.home.bind(this)} /></p>
        </div>
    }
}

export default ErrorSample
